<template>
  <div class="agreement-page">
    
        <div style="width: 100%; height: 65px; position: fixed; background-color: black;"></div>
    <div class="container">
      <h1 class="title">中青网用户协议</h1>
      <!-- <p class="subtitle">生效日期：2025-11-04（最近更新）</p> -->

      <div class="card">
        <p>欢迎您使用中青网。本《用户协议》（以下简称“本协议”）是您与中青网之间关于您注册、登录、使用中青网网站及相关产品/服务（以下统称“本服务”）所订立的协议。请您在使用本服务前仔细阅读并充分理解本协议的全部内容，特别是以加粗方式提示您的条款。</p>
        <p>当您点击“同意”或实际使用本服务，即视为您已阅读并同意接受本协议的全部内容。</p>
      </div>

      <div class="section">
        <h2>一、协议范围与变更</h2>
        <ol>
          <li>本协议适用于您通过中青网提供的网页、H5、移动端以及后续可能推出的其他形态使用本服务的行为。</li>
          <li>中青网有权根据业务需要对本协议进行修订与更新，并以网站公告或页面提示等方式进行公布并生效。<strong>若您不同意更新内容，应立即停止使用本服务；若您继续使用，即视为接受更新后的协议。</strong></li>
        </ol>
      </div>

      <div class="section">
        <h2>二、账户注册与使用</h2>
        <ol>
          <li>您应当具备完全民事行为能力。<strong>若您为未成年人，请在监护人监护、指导下阅读并决定是否同意本协议。</strong></li>
          <li>注册账户时，您应提供真实、准确、完整的注册信息，并保证联系方式等信息持续有效。</li>
          <li>您应妥善保管账户与密码信息。<strong>因账户保管不当造成的损失由您本人承担。</strong></li>
          <li>如发现账户被未经授权使用，请立即通知中青网处理。</li>
        </ol>
      </div>

      <div class="section">
        <h2>三、服务内容与使用规范</h2>
        <p>中青网是面向音乐与漫画的综合性平台，可能提供包括但不限于：音乐素材浏览/购买、漫画阅读/解锁、创作上传、互动社区等服务。您在使用过程中应遵守以下规范：</p>
        <ol>
          <li>遵守法律法规，不得发布、上传、传播违法违规或侵权内容，不得利用本服务从事任何违法犯罪活动。</li>
          <li>尊重他人权利，不得侵犯他人合法权益，包括但不限于著作权、商标权、名誉权、隐私权等。</li>
          <li>不得干扰或破坏本服务的正常运行，包括但不限于：<strong>恶意抓取、批量爬取、逆向工程、注入攻击、刷量刷评、冒用身份</strong>等行为。</li>
          <li>遵守平台发布的各项规则、公告、流程指引与运营规范。</li>
        </ol>
      </div>

      <div class="section">
        <h2>四、内容与知识产权</h2>
        <ol>
          <li>中青网或其合作方对平台中呈现的内容（包括但不限于文字、图片、音频、视频、界面设计、版式框架、数据资料、软件等）享有合法权利。未经权利人书面许可，<strong>您不得以任何方式复制、转载、传播、改编、汇编、镜像或用于商业用途。</strong></li>
          <li>您在中青网上传、发布的原创内容，著作权归属您或合法权利人。您同意授予中青网为提供服务所必要的非独占、可撤销、全球范围的使用许可（仅限展示、传播、存储、转码、内容推荐等与服务直接相关之合理范围）。</li>
          <li>对于您上传的非原创内容，您应确保已取得充分授权，且不侵犯任何第三方权利。因您上传或发布之内容引发的纠纷与损失，由您自行承担。</li>
        </ol>
      </div>

      <div class="section">
        <h2>五、付费、虚拟币与解锁</h2>
        <ol>
          <li>平台可能提供付费服务、虚拟币（“硬币”）充值与消费等。虚拟币的充值比例、使用范围、有效期（如有）以页面公示为准。</li>
          <li>硬币用于解锁音乐素材（示例：10~30 硬币/个）与漫画章节（示例：190 硬币/话）等权益。<strong>虚拟币一经充值，除法律法规另有规定外，不支持退换。</strong></li>
          <li>您应当通过平台指定的支付渠道完成付款，并确保支付来源的合法性。</li>
          <li>如因网络、第三方支付原因导致订单异常，请及时联系客服协助处理。</li>
        </ol>
      </div>

      <div class="section">
        <h2>六、隐私与个人信息保护</h2>
        <ol>
          <li>中青网将按照法律法规及《隐私政策》处理您的个人信息，具体规则以《隐私政策》为准。</li>
          <li>除法律法规规定或为提供服务之必要情况外，中青网不会向无关联的第三方提供您的个人信息。</li>
          <li>您应了解并同意，为实现推荐与风控等目的，平台可能对您的使用行为进行匿名化/去标识化统计分析。</li>
        </ol>
      </div>

      <div class="section">
        <h2>七、用户行为规范与处罚</h2>
        <ol>
          <li>如您违反本协议或相关规则，中青网有权视情节采取包括但不限于<strong>警告、删除内容、限制功能、冻结或注销账户、追究法律责任</strong>等处理措施。</li>
          <li>因您的行为导致中青网或第三方遭受损失的，您应承担全部赔偿责任。</li>
        </ol>
      </div>

      <div class="section">
        <h2>八、未成年人保护</h2>
        <p>中青网重视未成年人保护。未成年人应在监护人监护、指导下使用本服务，并合理安排使用时间，避免沉迷互联网。</p>
      </div>

      <div class="section">
        <h2>九、免责声明</h2>
        <ol>
          <li>中青网将尽力提供稳定、连续的服务，但<strong>不对服务的绝对不间断或错误进行保证</strong>，包括但不限于网络、设备、第三方服务商原因导致的中断或故障。</li>
          <li>您应当自行备份重要数据。因不可抗力或意外事件造成的服务中断、数据丢失、损失或损害，中青网在法律允许的最大范围内免责。</li>
        </ol>
      </div>

      <div class="section">
        <h2>十、责任限制</h2>
        <p>在适用法律允许的范围内，<strong>对于因使用本服务而产生的间接、偶然、特殊、惩罚性或后果性损害，中青网不承担责任。</strong>中青网对您承担的全部责任以您在造成损害之日前连续六个月内为本服务实际支付的对价为上限（不含虚拟币未消耗余额）。</p>
      </div>

      <div class="section">
        <h2>十一、协议终止与账户注销</h2>
        <ol>
          <li>您可按照平台流程申请注销账户。注销完成后，账户信息及相关数据将依据法律法规与《隐私政策》进行处置。</li>
          <li>如您存在违法违规或严重违约行为，中青网有权在通知后终止本协议、采取冻结或注销等措施。</li>
        </ol>
      </div>

      <div class="section">
        <h2>十二、争议解决与适用法律</h2>
        <ol>
          <li>本协议的订立、执行、解释及争议解决适用中华人民共和国法律。</li>
          <li>如双方就本协议发生争议，首先应友好协商；协商不成的，您同意将争议提交至中青网所在地有管辖权的人民法院诉讼解决。</li>
        </ol>
      </div>

      <div class="section">
        <h2>十三、投诉与联系方式</h2>
        <p>如您对本服务或本协议有任何疑问、建议或投诉，请通过以下方式联系我们：</p>
        <ul>
          <li>客服邮箱：zqwzbs@126.com</li>
          <li>客服工作时间：每日 9:00-22:00（法定节假日照常）</li>
        </ul>
      </div>

      <div class="card foot">
        <p>提示：继续使用中青网，即表示您已阅读并同意本《中青网用户协议》及相关规则。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YHAgreement',
}
</script>

<style scoped lang="scss">
.agreement-page { background:#fff; color:#0f172a; }
.container { max-width: 900px; margin: 0 auto; padding: 92px 16px 60px; }
.title { margin:0; font-size: 32px; font-weight: 800; letter-spacing: -.3px; }
.subtitle { margin: 6px 0 16px; color:#64748b; }

.card { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.card.foot { background:#f8fafc; }

.section { background:#fff; border:1px solid #e2e8f0; border-radius: 12px; padding: 14px; margin-bottom: 14px; }
.section h2 { margin:0 0 10px; font-size: 16px; font-weight: 800; color:#0f172a; }
.section p { margin: 8px 0; color:#334155; line-height: 1.75; }
.section ol, .section ul { margin: 8px 0 0 18px; color:#334155; line-height: 1.75; }
.section li { padding-left: 4px; }

/* 小屏优化 */
@media (max-width: 520px) {
  .container { padding: 88px 12px 40px; }
  .title { font-size: 24px; }
}
</style>
